// extracted by mini-css-extract-plugin
export default {"zoomModal":"H3-z"};